export const OTPAD_V1ResourcesDE: OTPAD_V1ResourcesBSInterface = {
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  input: {
    datum: {
      name: "datum",
      label: "Datum der Aufgabenerledigung",
      placeholder: "Datum eingeben",
    },
    vrstaOtpada: {
      name: "vrstaOtpada",
      label: "Abfallart eingeben",
      placeholder: "Abfallart eingeben",
    },
    jedinicaMjere: {
      name: "jedinicaMjere",
      label: "Maßeinheit eingeben",
      placeholder: "Maßeinheit eingeben",
    },
    primaoc: {
      name: "primaoc",
      label: "Empfängername eingeben",
      placeholder: "Empfängername eingeben",
    },
    adekvatnoPrikupljen: {
      name: "adekvatnoPrikupljen",
      label: "Auswählen, ob Abfall ordnungsgemäß gesammelt wurde",
      error: "Bitte wählen Sie aus, ob Abfall ordnungsgemäß gesammelt wurde",
      placeholder:
        "Bitte wählen Sie aus, ob Abfall ordnungsgemäß gesammelt wurde",
    },
    korektivnaMjera: {
      name: "korektivnaMjera",
      label: "Korrekturmaßnahme",
      placeholder: "Korrekturmaßnahme eingeben",
    },
    kolicina: {
      name: "kolicina",
      label: "Menge",
      placeholder: "Menge eingeben",
    },
  },
  type: {
    EvdLabel: "Evidenztyp",
    Name: "type",
    Placeholder:
      "Eingeben: Regelmäßig, außerordentlich, allgemein, wöchentlich, monatlich, jährlich...",
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
  dropdownOptions: {
    da: "Ja",
    ne: "Nein",
    undefined: "Bitte wählen Sie ein Feld aus",
  },
};

interface InputField {
  name: string;
  label: string;
  placeholder?: string;
  error?: string;
}

interface Input {
  datum: InputField;
  vrstaOtpada: InputField;
  jedinicaMjere: InputField;
  primaoc: InputField;
  adekvatnoPrikupljen: InputField;
  korektivnaMjera: InputField;
  kolicina: InputField;
}

interface Type {
  EvdLabel: string;
  Name: string;
  Placeholder: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IDropdownOptions {
  da: string;
  ne: string;
  undefined: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface OTPAD_V1ResourcesBSInterface {
  input: Input;
  type: Type;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  dropdownOptions: IDropdownOptions;
  errors: IErrors;
}
